import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2, Mail } from "lucide-react";
import { Button } from "../components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterVerifyPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Invalid confirmation link — no token provided.");
      return;
    }
    const verify = async () => {
      try {
        const { data } = await axios.get(`${API}/newsletter/verify?token=${token}`);
        setStatus("success");
        setMessage(data.message || "Subscription confirmed!");
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Invalid or expired confirmation link.");
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-indigo-50 flex items-center justify-center p-4" data-testid="newsletter-verify-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <Mail className="w-12 h-12 mx-auto text-indigo-500 mb-2" />
          <h1 className="text-2xl font-bold text-slate-900">Newsletter Subscription</h1>
        </div>

        {status === "loading" && (
          <div className="flex flex-col items-center gap-3" data-testid="newsletter-verify-loading">
            <Loader2 className="w-8 h-8 animate-spin text-indigo-500" />
            <p className="text-slate-600">Confirming your subscription...</p>
          </div>
        )}

        {status === "success" && (
          <div className="flex flex-col items-center gap-3" data-testid="newsletter-verify-success">
            <CheckCircle className="w-12 h-12 text-emerald-500" />
            <p className="text-slate-700 text-lg font-medium">{message}</p>
            <p className="text-slate-500 text-sm">You'll now receive our AI learning tips and updates.</p>
          </div>
        )}

        {status === "error" && (
          <div className="flex flex-col items-center gap-3" data-testid="newsletter-verify-error">
            <XCircle className="w-12 h-12 text-red-500" />
            <p className="text-slate-700 text-lg font-medium">{message}</p>
          </div>
        )}

        <div className="mt-8">
          <Link to="/">
            <Button variant="outline" data-testid="newsletter-verify-home-btn">Back to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
